<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox">
        <el-form ref="form" :model="search" label-width="120px" size="small">
          <!-- <el-form-item label="文档类型："
            ><el-radio-group v-model="search.fileType">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button
                v-for="(resource, i) in conditions.wendangleixingList"
                :key="'resource' + i"
                :label="resource.key"
                >{{ resource.value }}</el-radio-button
              >
            </el-radio-group></el-form-item
          > -->
          <!-- <el-form-item label="资源类别："
            ><el-radio-group v-model="search.resourceTypeId">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button
                v-for="(resource, i) in conditions.resourceTypeData"
                :key="'resource' + i"
                :label="resource.code"
                >{{ resource.name }}</el-radio-button
              >
            </el-radio-group></el-form-item
          > -->
          <el-form-item label="时间筛选："
            ><el-date-picker
              v-model="search.beginDate"
              :picker-options="pickerOptionsStart"
              size="small"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 150px"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            <font style="padding: 0 10px">至</font>
            <el-date-picker
              v-model="search.endDate"
              :picker-options="pickerOptionsEnd"
              size="small"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 150px"
              placeholder="选择结束日期"
            >
            </el-date-picker
          ></el-form-item>

          <el-form-item
            ><el-button type="primary" @click="getDataList" size="small">查询</el-button>
            <el-button type="primary" @click="daochu" size="small">导出</el-button>
            <el-button @click="clear" size="small">重置</el-button></el-form-item
          >
        </el-form>
      </div>

      <div class="contentBox">
        <el-table
          stripe
          :data="tableData"
          style="width: 100%"
          @sort-change="sort"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="typeName" label="资源类别"></el-table-column>
          <!-- <el-table-column
            prop="fileTypeName"
            label="文档类型"
          ></el-table-column> -->
          <el-table-column
            prop="shareCount"
            sortable="custom"
            label="共享量"
          ></el-table-column>
          <el-table-column
            prop="visitedSum"
            sortable="custom"
            label="浏览量"
          ></el-table-column>
          <el-table-column
            prop="favoriteSum"
            sortable="custom"
            label="收藏量"
          ></el-table-column>
          <el-table-column
            prop="downloadSum"
            sortable="custom"
            label="下载量"
          ></el-table-column>
        </el-table>
        <!-- <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.pageAll"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import Axios from "axios";
export default {
  name: "statisticsResources",
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endDate) {
            return time.getTime() > new Date(this.search.endDate).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.beginDate) {
            return time.getTime() < new Date(this.search.beginDate).getTime() - 86400000;
          }
        },
      },
      ccc: "按资源统计",
      search: {
        fileType: "",
        resourceTypeId: "",
        beginDate: "",
        endDate: "",
        page: 1,
        size: 10,
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      conditions: {
        wendangleixingList: [],
      },
      tabH: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 150;
    });
    this.getWenDangLeixing();
    this.getDataList();
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (index === 1) {
          sums[index] = "";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    sort({ column, prop, order }) {
      let o = order == "ascending" ? "asc" : order == "descending" ? "desc" : "asc";
      this.search.sortString = prop + " " + o;
      this.getDataList();
    },
    getWenDangLeixing() {
      // 获取文档类型
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取文档类型", res);
        this.conditions.wendangleixingList = res;
      });
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.conditions.resourceTypeData = res;
      });
    },
    // 获取统计列表
    getDataList() {
      let urlLink = `/server/resource/stat/statByResource`;
      // let param = this.search;
      this.$ajax.post(urlLink, this.search).then((res) => {
        console.log("获取统计列表", res);
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    //清空查询条件
    clear() {
      this.search.beginDate = "";
      this.search.endDate = "";
      this.search.fileType = "";
      this.search.resourceTypeId = "";
    },
    // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getDataList();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getDataList();
    },
    // 导出
    daochu() {
      let param = this.search;
      var requestUrl = "/server/resource/stat/export/statByResource";
      Axios({
        method: "post",
        url: requestUrl,
        data: param,
        responseType: "blob",
      })
        .then((res) => {
          fileDownload(res.data, "按资源统计.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/statistics/resources.vue